import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router";
import { AuthContext } from "../Auth/Auth";

const ProtectedRoute = () => {
  const { currentUser } = useContext(AuthContext);

  // If the user is not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If the user is authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute;
